import { Routes } from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ''
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.routes')
      .then(m => m.authRoutes)
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/admin/admin.routes')
        .then(m => m.adminRoutes),
    canMatch: [AuthGuard],
  }
];
